import { FaCalendarAlt } from "@react-icons/all-files/fa/FaCalendarAlt";
import { FaClock } from "@react-icons/all-files/fa/FaClock";
import { Link } from "gatsby";
import React from "react";
import Title from "../../atoms/title/title";
import "./related.scss";

export interface IRelatedProps {
  titulo?: string;
  className?: string;
  limit?: number;
  gridElements: {
    categoria: string;
    categoriaSlug: string;
    descripcion: string;
    fecha: string;
    imagen: string;
    slug: string;
    tiempo: string;
    titulo: string;
  }[];
}

const Related = (props: IRelatedProps) => {
  const compClass = "o-related";
  const { titulo, gridElements } = props;

  return (
    <div className={`${compClass}`}>
      {titulo && <Title haveInnerHTML={true} titulo={titulo} />}
      <div className={`${compClass}__container`}>
        {gridElements.map((element, key) => (
          <div className={`${compClass}__card`} key={key}>
            <Link to={"/" + element.slug} className={`${compClass}__card-link`}>
              <div
                className={`${compClass}__card-img`}
                style={{ backgroundImage: `url(${element.imagen})` }}
              ></div>
            </Link>
            <Link to={element.categoriaSlug}>
              <p className={`${compClass}__card-category`}>
                {element.categoria}
              </p>
            </Link>
            <Link to={"/" + element.slug}>
              <p className={`${compClass}__card-title`}>{element.titulo}</p>
            </Link>
            <div className={`${compClass}__card-description`}>
              {element.fecha && (
                <span className={`${compClass}__card-date`}>
                  <FaCalendarAlt /> {element.fecha}
                </span>
              )}
              {element.tiempo && (
                <span className={`${compClass}__card-time`}>
                  <FaClock /> {element.tiempo}
                </span>
              )}
            </div>
            <p className={`${compClass}__card-content`}>
              {element.descripcion}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Related;
